import React, {useState, useEffect} from "react";
import {Checkbox} from "antd";
import {images} from "../../../constants";
import './PaymentProvidersPermission.scss'

const CheckboxGroup = Checkbox.Group;

const providerMeta = {
    payme: {
        label: "Payme",
        icon: images.paymeLogo,
    },
    click: {
        label: "Click",
        icon: images.clickLogo,
    },
    uzum: {
        label: "Uzum",
        icon: images.uzumLogo,
    },
    anor: {
        label: "Anor",
        icon: images.anorLogo,
    },
};

const PaymentProvidersPermissionCheckBox = ({
                                                t,
                                                providerPermissions,
                                                onChange
                                            }) => {
    const [checkedList, setCheckedList] = useState([]);
    const [indeterminate, setIndeterminate] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const options = Object.keys(providerPermissions);
    const checkboxOptions = options.map((provider) => ({
        value: provider,
        label: (
            <span className="providers-permission__option">
                {providerMeta[provider]?.icon ? (
                    <img src={providerMeta[provider].icon} alt="" aria-hidden="true"/>
                ) : null}
                <span>{providerMeta[provider]?.label || provider}</span>
            </span>
        ),
    }));

    useEffect(() => {
        const initialCheckedList = options.filter(provider => providerPermissions[provider]);
        setCheckedList(initialCheckedList);
        updateCheckAllStatus(initialCheckedList);
    }, [providerPermissions]);

    const updateCheckAllStatus = (list) => {
        setIndeterminate(list.length > 0 && list.length < options.length);
        setCheckAll(list.length === options.length);
    };

    const onCheckAllChange = (e) => {
        const newCheckedList = e.target.checked ? options : [];
        setCheckedList(newCheckedList);
        updateCheckAllStatus(newCheckedList);
        onChange(newCheckedList);
    };

    const onGroupChange = (list) => {
        setCheckedList(list);
        updateCheckAllStatus(list);
        onChange(list);
    };

    return (
        <div className="providers-permission">
            <label className="providers-permission__label">{t("pages.user.profile.label9")}</label>
            <div className="providers-permission__full">
                <Checkbox
                    indeterminate={indeterminate}
                    onChange={onCheckAllChange}
                    checked={checkAll}
                >
                    {t("pages.user.profile.label10")}
                </Checkbox>
            </div>
            <div className="providers-permission__grid">
                <CheckboxGroup
                    options={checkboxOptions}
                    value={checkedList}
                    onChange={onGroupChange}
                />
            </div>
        </div>
    );
};

export default PaymentProvidersPermissionCheckBox;
